import React, { useContext, } from 'react';
import { useReduxSelector, useReduxDispatch } from '../../../redux/hooks';
import { TicketApi } from '../../../redux/api/TicketApi';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { Card, CardHeader, CardBody, CardFooter } from '@progress/kendo-react-layout';
import './TicketDetailsPage.scss';
import CustomForm from './Sections/CustomForm';
import Actions from './Sections/Actions';
import { IUserProfile } from '../../../types/User/IUserProfile';
import { RevUserContext } from '../../../context/UserContext';
import AddAction from './Sections/AddAction';
import { RightBar } from '../../RightBar/RightBar';
import Dockbar from './Sections/Dock/Dockbar';
import AISummary from './Sections/AISummary';
import { setActionExpanded } from '../../../slices/TicketDetailUISlice';
import { setDetails } from '../../../slices/TicketDetailSlice';
import ActionToolbar from './Sections/ActionToolbar';
import EmailAction from './Sections/Tools/Email/EmailAction';
import TicketHeader from './Sections/TicketHeader';
import { ITicketProps } from '../../../types/Ticket/ITicket';
import '../../../styles/themes.scss';
import createTheme from '../../../styles/themes';
import Sidebar from './Sections/Sidebar';
import TicketStoryLine2 from './Sections/Tools/Storyline/TicketStoryLine2';
import LegacyBanner from './Sections/LegacyBanner';
import ActionExpander from './Sections/ActionExpander';
import { Spinny } from '../../Nav/Spinny';
import ErrorCard from '../../Common/ErrorCard';
import { CloseDialogProvider } from './Sections/Tools/Close/CloseDialogContext';
import ActionTabs from './Sections/ActionTabs';
import TicketRoutes from '../TicketRoute';
import Progress from '../../Gameplan/Progress';
import { isMobile } from 'react-device-detect';
import GameplanDetails from '../../Gameplan/GameplanDetails';

const TicketDetailsPage = () => {
    const navigate = useNavigate();
    const profile = useContext<IUserProfile>(RevUserContext)
    const { ticketId } = useParams()
    const { data: details, isFetching, error } = TicketApi.useGetTicketDetailsQuery({ ticketId: Number(ticketId) });
    const dispatch = useReduxDispatch();
    const viewName = useReduxSelector(state => state.ticketDetailsUI.viewName);
    const [markAsRead] = TicketApi.useReadTicketMutation();

    if (isFetching === false && error && error['status'] === 404) {
        navigate('/ticket/not-found');
    }


    React.useEffect(() => {
        if (details) {
            console.log('TicketDetailsPage mounted', ticketId);
            dispatch(setDetails(details));
            markTicketAsRead();
        }

    }, [details]);


    const markTicketAsRead = () => {
        markAsRead({ ticketId: Number(ticketId) }).unwrap();
    }

    //if (!details) return <Spinny /


    // return <><Dockbar />
    //     <Actions {...details} /></>
    //Onlt show loading on initial fetch when details is null OR when changing tickets and the Ticket IDs don't match
    const props = {
        ...details, ID: parseInt(ticketId),
        Is_Loading: details === null ? isFetching : (isFetching && ticketId !== details?.ID.toString())
    } as ITicketProps

    const pageThemeCSS = createTheme(profile.Body_Hex_Color, profile?.Body_Style, profile?.Body_Image_Url);

    // function useTraceUpdate(props) {
    //     const prev = useRef(props);
    //     useEffect(() => {
    //         const changedProps = Object.entries(props).reduce((ps, [k, v]) => {
    //             if (prev.current[k] !== v) {
    //                 ps[k] = [prev.current[k], v];
    //             }
    //             return ps;
    //         }, {});
    //         if (Object.keys(changedProps).length > 0) {
    //             //console.warn('Changed props:', changedProps);
    //         }
    //         prev.current = props;
    //     });
    // }

    // useTraceUpdate(props);

    //log every time props change
    // useEffect(() => {
    //     console.log('props changed', props);
    // }, [props]);

    if (error && error['originalStatus'] === 500) {
        console.log('ERROR', error);
        return <ErrorCard message={`Unexpected error while fetching details for ticket #${ticketId}. Code 500 API error: `} details={error['data']} />
    }

    //First load
    if (!details) return <Spinny />
    return (<>
        <CloseDialogProvider>
            <TicketRoutes />
            <RightBar>
                <div className={`ticket-details-page overflow-auto`} style={pageThemeCSS}>
                    <div className="container">
                        <LegacyBanner {...props} />
                        {/* <Link to={`/`} className="d-flex align-items-center">&lt; Home</Link> */}
                        <Outlet></Outlet>
                        <div className="row">
                            <Sidebar {...props} >
                                <div className="col content">
                                    <Dockbar {...details} />
                                    <TicketHeader  {...props} />
                                    {!isMobile && <Progress {...props} />}
                                    {/* Custom Forms */}
                                    {!props.Is_Loading && <CustomForm {...details} />}
                                    <ActionTabs />

                                    <div className="actions-section">
                                        <Card>
                                            <CardHeader className='header'>
                                                <ActionToolbar {...props} />
                                            </CardHeader>
                                            <CardBody>
                                                <ActionExpander />
                                                {viewName === 'notes' && <div className="action-form">
                                                    {/* <div className={showAction ? 'action-form-hidden action-form d-flex flex-column' : 'action-form-hidden d-flex flex-column'}> </div> */}
                                                    <div className={'collapse'} id='collapseAction'>
                                                        <AddAction showHeader={true} ticket={details} onsubmitted={() => dispatch(setActionExpanded(0))} onclosed={() => dispatch(setActionExpanded(0))} />
                                                    </div>
                                                    <div className={'collapse'} id='collapseEmail'>
                                                        <EmailAction onpopout={() => dispatch(setActionExpanded(0))} onsubmitted={() => dispatch(setActionExpanded(0))} onclosed={() => dispatch(setActionExpanded(0))} />
                                                    </div>
                                                    <Actions {...props} />
                                                </div>}
                                                {viewName === 'summary' && <AISummary {...props} />}
                                                {viewName === 'timeline' && <TicketStoryLine2 {...props} />}
                                                {viewName === 'gameplan' && <GameplanDetails {...props} />}
                                            </CardBody>
                                            <CardFooter></CardFooter>
                                        </Card>
                                    </div>
                                </div>
                            </Sidebar>
                        </div>
                    </div >
                </div>
            </RightBar >
        </CloseDialogProvider>
    </>
    );
};

export default TicketDetailsPage;